import OptionsLimiter from './OptionsLimiter';

const els = document.querySelectorAll('.js-options-limiter');

for (let el of els) {
    new OptionsLimiter(el);
}
